import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { AppService } from 'src/_services/app.service';
import { events,markets } from 'src/_constants/color';

@Component({
  selector: 'app-preview-screen',
  templateUrl: './preview-screen.component.html',
  styleUrls: ['./preview-screen.component.scss']
})
export class PreviewScreenComponent implements OnInit {
  @Input() provider: string = "";
  @Input() primary: string = "";
  @Input() background: string = "";
  @Input() subHeaderColor: string = "";
  @Input() tableBG: string = "";
  @Input() textColor: string = "";
  @Input() tableHead: string = "";
  @Input() defaultColor: string = "";
  @Input() gradient1: string = "";
  @Input() gradient2: string = "";
  sports = events;
  markets = markets;
  isTableCollapsed: boolean[] = Array(this.markets.length).fill(false);

  constructor(
    private appService : AppService,
  ) { }

  ngOnInit() {
    this.updateColors();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateColors();
  }

  updateColors(): void {
    document.documentElement.style.setProperty('--primary', this.primary);
    document.documentElement.style.setProperty('--background', this.background);
    document.documentElement.style.setProperty('--subHeaderColor', this.subHeaderColor);
    document.documentElement.style.setProperty('--tableBG', this.tableBG);
    document.documentElement.style.setProperty('--textColor', this.textColor);
    document.documentElement.style.setProperty('--tableHead', this.tableHead);
    document.documentElement.style.setProperty('--defaultColor', this.defaultColor);
    document.documentElement.style.setProperty('--gradient1', this.gradient1);
    document.documentElement.style.setProperty('--gradient2', this.gradient2);
  }

  toggleTableCollapse(index: number) {
    this.isTableCollapsed[index] = !this.isTableCollapsed[index];
  }

  getEventDate = (date: number) => {
    return moment(date).format("MMM DD hh:mm A");
  };

  getTextColor(value) {
    let hexColor = document.documentElement.style.getPropertyValue(value)
    var r = parseInt(hexColor.substring(1, 3), 16);
    var g = parseInt(hexColor.substring(3, 5), 16);
    var b = parseInt(hexColor.substring(5, 7), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 186 ? '#000' : '#fff';
  }
}
